module.exports = __webpack_public_path__ + "static/media/choithramsFooterMobile.11e86085.png";